export const getRowsToUse = (
  selectionMode: string | undefined,
  selectedRows: any[],
  currentRow: any,
  data: any[] | undefined
): any[] => {
  switch (selectionMode) {
    case 'dontcare':
      return [];
    case 'dontcare_useall':
      //all in filter
      return data || [];
    case 'any':
      return [...selectedRows, ...(currentRow ? [currentRow] : [])];
    case 'justone':
      return currentRow
        ? [currentRow]
        : selectedRows.length === 1
          ? selectedRows
          : [];
    case 'oneormore':
      return selectedRows.length > 0
        ? selectedRows
        : currentRow
          ? [currentRow]
          : [];
    default:
      return [];
  }
};
